export const Routes = {
  MAIN: "/",
  PROJECTS: "/projects",
  DOCS: "/docs",
  COOKIES: "/docs/cookies",
  PRIVACY: "/docs/privacy",
  TERMS: "/docs/terms",
} as const;

export const Anchors = {
  ABOUT: "#about",
  SERVICES: "#services",
  PROJECTS: "#projects",
  CLIENTS: "#clients",
  CONTACTS: "#contacts",
} as const;
